// Copyright 2026. WebPros International GmbH. All rights reserved.

import { Translate } from '@plesk/ui-library';
import { Dialog } from 'common/components/Dialog/Dialog';
import { IComputeResourceRecoveryReadinessStatusResponse } from 'common/api/resources/DisasterRecovery';
import ErrorMessage from 'admin/disasterRecovery/components/ErrorMessage/ErrorMessage';

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    compatibilityDetails: IComputeResourceRecoveryReadinessStatusResponse['destination_compute_resources'][number]['compatibility_details'] | null;
}

export default function VirtualizationTypesConflictDialog({
    isOpen,
    onClose,
    compatibilityDetails,
}: IProps) {

    const kvmNotSupported =
        'kvm' in (compatibilityDetails?.supported_virtualization_types ?? {}) &&
        !compatibilityDetails?.supported_virtualization_types.kvm;

    const vzNotSupported =
        'vz' in (compatibilityDetails?.supported_virtualization_types ?? {}) &&
        !compatibilityDetails?.supported_virtualization_types.vz;

    return (
        <Dialog
            isOpen={isOpen}
            heading={<Translate content="disasterRecovery.readinessStatus.destinationComputeResources.table.virtualizationTypes" />}
            size={'sm'}
            closeHandler={onClose}
        >
            {kvmNotSupported && (
                <ErrorMessage>
                    <Translate content="disasterRecovery.readinessStatus.destinationComputeResources.dialogs.virtualizationTypes.kvmNotSupported" />
                </ErrorMessage>
            )}

            {vzNotSupported && (
                <ErrorMessage>
                    <Translate content="disasterRecovery.readinessStatus.destinationComputeResources.dialogs.virtualizationTypes.vzNotSupported" />
                </ErrorMessage>
            )}
        </Dialog>
    );
}